import React from 'react'
import { NextPage } from 'next'
import PublicLayout from 'src/components/Layout/public'
import { Section } from 'src/components/Common/Section'
import { colors } from 'src/theme/colors'
import { useRouter } from 'next/router'
import { Title } from 'src/components/Common'
import { Modules } from 'src/components/Curso/modules'
import TitleWrapper from 'src/components/Common/TitleWrapper'
import ReactPlayer from 'react-player'
import { Bio, BoxImage, CategoryArea, TeacherContainer } from 'src/components/Teacher/styles'
import { CategoryMenu } from 'src/components/Common/CategoryMenu'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/store/rootReducers'
import { getTeacherRequest } from 'src/store/teachers'
import { TeacherSkeleton } from 'src/components/Skeleton/teacher'
import { useTranslation } from 'react-i18next'
import formatText from 'src/utils/formatText'

const TeacherPage: NextPage = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { slug } = router.query as { slug: string }
  const teacher = useSelector((state: State) => state.teachers.teacher)
  const isLoading = useSelector((state: State) => state.teachers.isLoading)

  // eslint-disable-next-line react/jsx-key
  const bio = formatText(teacher?.bio)

  React.useEffect(() => {
    if (slug) {
      ;(async () => {
        await getTeacher()
      })()
    }
  }, [slug, router.isReady])

  async function getTeacher() {
    dispatch(getTeacherRequest(slug))
  }

  const renderList = () => {
    if (teacher) {
      return (
        <>
          {teacher.categories.length > 0 && (
            <CategoryArea>
              <h3 className="title">
                {t('teacher.titleCategory')} {teacher.name}
              </h3>
              <CategoryMenu categories={{ data: teacher.categories }} />
            </CategoryArea>
          )}

          {teacher.lessons.length > 0 && (
            <Section preset="coursesTeacher" titleTx="teacher.titleLastLesson">
              <Modules lessons={teacher?.lessons} linkType="lesson" marginLeft={0} />
            </Section>
          )}
        </>
      )
    }
  }

  return (
    <PublicLayout showCategory={false}>
      <TitleWrapper>
        <BoxImage
          image={
            teacher
              ? teacher.imageUrl
              : 'https://res.cloudinary.com/cordasemusica/image/upload/f_webp/v1678224793/avatar_zrtqux.png'
          }
        >
          <div />
        </BoxImage>
        <Title
          borderMargin="medium"
          size="lg"
          borderColor={colors.palette.white}
          tx={teacher ? teacher.name : ''}
          iconSource={teacher?.imageUrl}
          hasBorder
          theme="light"
        />
        <small>{teacher?.occupation}</small>
      </TitleWrapper>
      <TeacherContainer>
        {isLoading ? (
          <TeacherSkeleton />
        ) : (
          <>
            {teacher?.video && (
              <div className="player-wrapper">
                <ReactPlayer
                  className="react-player"
                  controls
                  url={teacher?.video}
                  width="90%"
                  height="90%"
                />
              </div>
            )}

            <Bio>
              <h3 className="title">{t('teacher.titleBio')}</h3>
              <div>{bio}</div>
            </Bio>

            {renderList()}
          </>
        )}
      </TeacherContainer>
    </PublicLayout>
  )
}

export default TeacherPage
